import base from "../../../base";

export default async function fetchAvailableRanges(treeID) {
	const availableRanges = base.fetch(`trees/${treeID}/availableRanges`, { context: this });
	return availableRanges;
}
